module.exports = __webpack_public_path__ + "img/moderate.24a78eed.svg";